var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"channel-extension"},[_c('ChannelSummary',{on:{"dataChange":_vm.dataChange}}),_c('br'),_c('br'),_c('br'),_c('ChannelDetails',{attrs:{"timeInfo":_vm.timeInfo}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }